// import React from 'react';
// import { Box, Typography, CircularProgress } from '@mui/material';
// import './nodeProgress.less';

// const NodeProgress = ({ nodes }) => {
//     console.log('NodeProgress: Rendering with nodes=', nodes);
//     return (
//         <Box className="node-progress-container">
//             {nodes.map((node, index) => (
//                 <Box key={node.node_name} className="node-progress-item">
//                     <Typography variant="caption">
//                         {node.node_name.toUpperCase().replace(/_/g, ' ')}
//                     </Typography>
//                     {node.status === 'executing' ? (
//                         <CircularProgress size={12} sx={{ ml: 1 }} />
//                     ) : node.status === 'completed' ? (
//                         <span className="node-completed-dot" />
//                     ) : null}
//                 </Box>
//             ))}
//         </Box>
//     );
// };

// export default NodeProgress;


import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import './nodeProgress.less';

// Mapping of technical node names to user-friendly labels
const nodeNameMapping = {
    'intent_classifier': 'Understanding Your Question',
    'disambiguate': 'Identifying Entities',
    'proceed': 'Preparing to Fetch Data',
    'clarify': 'Asking for Clarification',
    'sql_agent': 'Fetching Data',
    'narrative_agent': 'Creating Narrative',
    'visualization_agent': 'Generating Visuals',
    'combine_messages': 'Finalizing Report',
    'knowledge_agent_flow': 'Searching & Preparing Knowledge Response',
    'whitespace_agent': 'Processing Whitespace Analysis',
    'competition_identification': 'Identifying Competitors',
    'bucket_size_identification': 'Analyzing Market Segments',
    'calculate_opportunity_size': 'Calculating Opportunity Size',
    'visualization': 'Generating Visuals',
    'narrative': 'Creating Narrative',
    'history_use_agent_flow': 'Processing Historical Context',
    'web_action_agent_flow': 'Browser Action'
};

const NodeProgress = ({ nodes }) => {
    console.log('NodeProgress: Rendering with nodes=', nodes);
    return (
        <Box className="node-progress-container">
            {nodes.map((node, index) => {
                // Get the user-friendly name from the mapping, or fallback to the transformed name
                const displayName = nodeNameMapping[node.node_name.toLowerCase()] || 
                    node.node_name.toUpperCase().replace(/_/g, ' ');
                return (
                    <Box key={node.node_name} className="node-progress-item">
                        <Typography variant="caption">
                            {displayName}
                        </Typography>
                        {node.status === 'executing' ? (
                            <CircularProgress size={12} sx={{ ml: 1 }} />
                        ) : node.status === 'completed' ? (
                            <span className="node-completed-dot" />
                        ) : null}
                    </Box>
                );
            })}
        </Box>
    );
};

export default NodeProgress;
//-----------------------------------------------------------------------------------

// import React, { useState, useEffect } from 'react';
// import { Box, Typography, CircularProgress, Collapse, Button } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import './nodeProgress.less';

// // Mapping of technical node names to user-friendly labels
// const nodeNameMapping = {
//     'intent_classifier': 'Understanding Your Question',
//     'disambiguate': 'Identifying Entities',
//     'proceed': 'Preparing to Fetch Data',
//     'clarify': 'Asking for Clarification',
//     'sql_agent': 'Fetching Data',
//     'narrative_agent': 'Creating Narrative',
//     'visualization_agent': 'Generating Visuals',
//     'combine_messages': 'Finalizing Report',
//     'knowledge_agent_flow': 'Searching & Preparing Knowledge Response'
// };

// const NodeProgress = ({ nodes }) => {
//     const [expanded, setExpanded] = useState(false);
//     const [completedNodes, setCompletedNodes] = useState([]);
//     const [showingHistory, setShowingHistory] = useState(false);
    
//     // Find the currently executing node (if any)
//     const executingNode = nodes.find(node => node.status === 'executing');
    
//     // Update completed nodes history when nodes change
//     useEffect(() => {
//         const newCompletedNodes = nodes
//             .filter(node => node.status === 'completed')
//             .map(node => ({
//                 ...node,
//                 displayName: nodeNameMapping[node.node_name.toLowerCase()] || 
//                     node.node_name.toUpperCase().replace(/_/g, ' ')
//             }));
            
//         if (newCompletedNodes.length > completedNodes.length) {
//             setCompletedNodes(newCompletedNodes);
//         }
//     }, [nodes]);

//     // Toggle the history expansion
//     const toggleExpanded = () => {
//         setExpanded(!expanded);
//         if (!expanded) {
//             setShowingHistory(true);
//         }
//     };

//     // Get display name for current executing node
//     const getDisplayName = (nodeName) => {
//         return nodeNameMapping[nodeName.toLowerCase()] || 
//             nodeName.toUpperCase().replace(/_/g, ' ');
//     };

//     // Determine if we should show the history button
//     const shouldShowHistoryButton = completedNodes.length > 0;

//     return (
//         <Box className="node-progress-container">
//             {/* Current executing node */}
//             {executingNode && (
//                 <Box className="node-progress-item node-executing">
//                     <Typography variant="caption">
//                         {getDisplayName(executingNode.node_name)}
//                     </Typography>
//                     <CircularProgress size={14} sx={{ ml: 1 }} />
//                 </Box>
//             )}

//             {/* History button */}
//             {shouldShowHistoryButton && (
//                 <Button 
//                     className="node-history-button"
//                     onClick={toggleExpanded}
//                     endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                     size="small"
//                 >
//                     View steps ({completedNodes.length})
//                 </Button>
//             )}

//             {/* Collapsible history */}
//             <Collapse in={expanded} timeout="auto" unmountOnExit className="node-history-collapse">
//                 <Box className="node-history-container">
//                     {completedNodes.map((node, index) => (
//                         <Box key={`${node.node_name}-${index}`} className="node-history-item">
//                             <CheckCircleOutlineIcon fontSize="small" className="node-history-check" />
//                             <Typography variant="caption">
//                                 {node.displayName}
//                             </Typography>
//                         </Box>
//                     ))}
//                 </Box>
//             </Collapse>
//         </Box>
//     );
// };

// export default NodeProgress;

